<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
    >
      <template slot="conteudo">
        <b-row>
          <b-col cols="12">
            <divisoria-descricao
              :titulo="'Prazos'"
              :descricao="'Defina os prazos de validade da proposta e próximo contato de agenda'"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-form-group
            label="Prazo de validade da proposta"
            class="col-4 mr-25"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Validade Proposta"
            >
              <b-select
                v-model="form.vencimentoProposta"
              >
                <option
                  v-for="$index in 365"
                  :key="$index"
                  :value="$index"
                >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
              </b-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Prazo do próximo contato de agenda"
            class="col-4"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Prazo Contato"
            >
              <b-select
                v-model="form.prazoProximaAgenda"
              >
                <option
                  v-for="$index in 365"
                  :key="$index"
                  :value="$index"
                >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
              </b-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="12">
            <divisoria-descricao
              :titulo="'Intervalo de cobrança'"
              :descricao="'Defina o intervalo de cobrança para as propostas, checklist e agenda'"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-form-group
            label="Proposta"
            class="col-2 mr-25"
          >
            <b-select
              v-model="form.cobrarCadaProposta"
            >
              <option :value="null" />
              <option
                v-for="$index in 31"
                :key="$index"
                :value="$index"
              >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
            </b-select>
          </b-form-group>
          <b-form-group
            label="Checklist"
            class="col-2 mr-25"
          >
            <b-select
              v-model="form.cobrarCadaChecklist"
            >
              <option :value="null" />
              <option
                v-for="$index in 31"
                :key="$index"
                :value="$index"
              >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
            </b-select>
          </b-form-group>
          <b-form-group
            label="Agenda"
            class="col-2"
          >
            <b-select
              v-model="form.cobrarCadaAgenda"
            >
              <option :value="null" />
              <option
                v-for="$index in 31"
                :key="$index"
                :value="$index"
              >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
            </b-select>
          </b-form-group>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="12">
            <div class="tag-observacoes">
              <legend style="font-size: 1rem; width: auto;">
                Observações (Condições gerais)</legend>
              <dropdown-tag
                ref="tagObservacao"
                :tags="tagObservacoes"
                @enviar-pai="addObservacao"
              />
            </div>
            <quill-editor
              ref="quillText"
              v-model="form.observacao"
              :options="opcoesTextArea"
            />
          </b-col>
        </b-row>
        <div style="margin-top: 20px;">
          <legend style="font-size: 1rem; width: auto;">
            E-mail cópia de segurança CCo do comercial e controle de vencimento
          </legend>
          <validation-provider
            #default="{ errors }"
            name="E-mail"
            rules="email"
          >
            <b-form-input
              ref="email"
              v-model="form.emailCCO"
              :state="errors.length > 0 ? false:null"
              placeholder="E-mail CCo (Opcional)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

        </div>
        <div>
          <div>
            <div>
              <legend style="font-size: 14px; padding-top:15px;">
                E-mail cópia propostas aprovadas (CC)</legend>
            </div>
          </div>
          <b-form-tags
            v-model="form.emailCC"
            input-id="tags-emails"
            placeholder=""
            separator=" "
            invalid-tag-text=""
            duplicate-tag-text=""
            :tag-validator="validator"
            :disabled="disable"
            :add-button-text="'Adicionar'"
            remove-on-delete
            tag-class="tags"
            @tag-state="onTagState"
          />
        </div>
        <small
          v-if="invalidTags.length > 0"
          class="text-danger"
        >Insira um email válido</small>
        <small
          v-else-if="duplicateTags.length > 0"
          class="text-danger"
        >E-mail já inserido nesse campo
        </small>
        <b-row class="mt-1">
          <b-col cols="12">
            <email-input
              :value="form.emailNotificacaoOmie"
              :label="'E-mail para envio das notificações Omie'"
              :require="false"
              @input="adicionarEmailOmie($event)"
            />
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="12">
            <email-input
              :value="form.emailNotificacaoCertificados"
              :label="'E-mail para envio das notificações de certificados'"
              :require="false"
              @input="adicionarEmailCertificado($event)"
            />
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col>
            <b-btn
              variant="none"
              size="sm"
              class="btn-outline-primary btn-none"
              @click="getUrlConsentimento"
            >
              Autenticar DocuSign
            </b-btn>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="4"
            class="mr-25"
          >
            <upload-parametrizacao
              ref="uploadArquivo"
              :label="'Arquivo de apresentação Auditar'"
              :id-upload="'arquivo'"
              :text="form.nomeArq"
              :visualizar="visualizarArquivo"
              @selecionado="selecionadoArquivo"
              @removido="arquivoRemovido"
            />
          </b-col>
          <b-col cols="4">
            <upload-parametrizacao
              ref="uploadVideo"
              :label="'Vídeo de apresentação Auditar'"
              :id-upload="'video'"
              :text="form.nomeVideo"
              :visualizar="visualizarVideo"
              @selecionado="selecionadoVideo"
              @removido="videoRemovido"
            />
          </b-col>
        </b-row>
      </template>
    </cadastro-base>

    <loading
      :is-loading="isLoading"
      :show-cancel-button="false"
    />

  </div>
</template>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.tag-comentarios, .tag-observacoes {
  display: flex;
  align-items: flex-end;
}

.dropdown-tag {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.ql-editor {
  max-height: 80px;
  overflow: auto;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}
</style>

<script>
/* eslint-disable no-underscore-dangle */
import { quillEditor } from 'vue-quill-editor'
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/services/api'
import docuSign from '@/shared/mixins/docu-sign/docu-sign'

export default {
  name: 'ParametrizacaoGeral',
  components: {
    CadastroBase,
    ValidationProvider,
    quillEditor,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    DropdownTag: () => import('@/shared/components/dropdown-tag/DropdownTag.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
    UploadParametrizacao: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/Geral/shared/upload-visualizacao-parametrizacao/UploadParametrizacao.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
  },
  data() {
    return {
      required,
      form: {
        emailCC: [],
        vencimentoProposta: null,
        prazoProximaAgenda: null,
        cobrarCadaProposta: null,
        cobrarCadaChecklist: null,
        cobrarCadaAgenda: null,
        observacao: '',
        emailCCO: '',
        arquivoSelecionado: false,
        videoSelecionadado: false,
        excluirArquivo: false,
        excluirVideo: false,
      },
      invalidTags: [],
      duplicateTags: [],
      valueArquivo: [],
      valueVideo: [],
      tagObservacoes: ['Pessoa', 'Prazo', 'Data de validade', 'Data de vencimento', 'Data da proposta (Envio)'],
      isLoading: false,
      opcoesTextArea: {
        modules: {
          toolbar: false,
        },
        placeholder: 'Informe uma descrição que será sugerida como padrão para todas as propostas comerciais',
      },
      quill: {},
    }
  },
  created() {
    this.carregar()
  },
  mounted() {
    this.quill = this.$refs.quillText.quill
  },
  methods: {
    carregar() {
      api.getParemtrizacaoGeral()
        .then(payload => {
          if (payload.data) {
            this.form = payload.data
          }
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        const form = { ...this.form }

        this.valueArquivo = this.$refs.uploadArquivo.value
        this.valueVideo = this.$refs.uploadVideo.value

        const formData = this.getFormDataBody(form)
        if (this.valueArquivo[0] || this.valueVideo[0]) {
          this.isLoading = true
        }
        api.salvarParametrizacaoGeral(formData)
          .then(() => {
            if (this.valueArquivo[0]) {
              this.form.nomeArq = this.valueArquivo[0].name
            }

            if (this.valueVideo[0]) {
              this.form.nomeVideo = this.valueVideo[0].name
            }
            this.isLoading = false
            resolve('Parametrização cadastrada com sucesso')
          })
          .catch(err => {
            this.isLoading = false
            reject(err)
          })
      })
    },
    cancelar() {
    },
    getFormDataBody(body) {
      const formData = new window.FormData()
      const fileArquivo = this.valueArquivo[0]
      const fileVideo = this.valueVideo[0]
      if (fileArquivo) {
        formData.append('files', fileArquivo.file, fileArquivo.filename || fileArquivo.name)
      }
      if (fileVideo) {
        formData.append('files', fileVideo.file, fileVideo.filename || fileVideo.name)
      }
      formData.append('body', JSON.stringify(body))

      return formData
    },
    addObservacao(value) {
      this.quill.insertText(this.quill.getSelection(true), value, 'bold', true)
      this.quill.setSelection(this.quill.getSelection(true).index + value.length)
      this.quill.insertText(this.quill.getSelection(true), ' ', 'bold', false)
    },
    visualizarArquivo() {
      return api.getUrlArquivo()
    },
    visualizarVideo() {
      return api.getUrlVideo()
    },
    selecionadoArquivo() {
      this.form.arquivoSelecionado = true
      this.form.nomeArq = ''
      this.form.excluirArquivo = false
      this.form.videoSelecionadado = this.$refs.uploadVideo.value[0] !== undefined
    },
    selecionadoVideo() {
      this.form.videoSelecionadado = true
      this.form.nomeVideo = ''
      this.form.excluirVideo = false
      this.form.arquivoSelecionado = this.$refs.uploadArquivo.value[0] !== undefined
    },
    arquivoRemovido() {
      this.form.arquivoSelecionado = false
      this.form.nomeArq = ''
      this.form.excluirArquivo = true
    },
    videoRemovido() {
      this.form.videoSelecionadado = false
      this.form.nomeVideo = ''
      this.form.excluirVideo = true
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    getUrlConsentimento() {
      docuSign.getLinkAutenticacao()
        .then(payload => {
          window.open(payload.data, '_blank').focus()
        })
    },
    adicionarEmailOmie(value) {
      this.form.emailNotificacaoOmie = value
    },
    adicionarEmailCertificado(value) {
      this.form.emailNotificacaoCertificados = value
    },
  },
}
</script>
